import React, { useState } from 'react';
import { isIP } from 'is-ip';

// styles
import {
  RightNavContainer,
  RightNavContainerFoot,
  RightNavContainerX,
  RightNavContainerXPar,
  RightNavSecDiv,
  RNCFBtn,
  RNCFBtn2,
  SBMSDiv3,
  SBMSInput2,
  SDMHeading,
  SDMHeadingP,
  SideBarMainDiv,
  TeamHeadBtnImgP,
  TeamHeadBtnImgPa,
} from './styles';
import { ErrorWarning } from './styles';
import cross from '../../Assets/images/cross.png';

const EditOrgOnPremServer = ({
  editOnPremServer,
  onGearEditApi,
  closeSideBar,
}) => {
  const [updateData, setUpdateData] = useState(editOnPremServer);
  const [error, setError] = useState({
    nickname: '',
    default_lan_ip: '',
    default_wan_ip: '',
  });

  const validateUpdateData = () => {
    const newErrors = {};
    const nickNameRegex = /^[a-zA-Z0-9\s]+$/;

    if (!updateData?.nickname) {
      newErrors.nickname = 'This field is required';
    } else if (nickNameRegex.test(updateData?.nickname) === false) {
      newErrors.nickname = 'Nickname must only contains letters, numbers, and spaces.';
    }

    if (updateData?.default_lan_ip.length > 0 && !isIP(updateData?.default_lan_ip)){
      newErrors.default_lan_ip = 'Invalid LAN IP';
    }
    if (updateData?.default_wan_ip.length > 0 && !isIP(updateData?.default_wan_ip)){
      newErrors.default_wan_ip = 'Invalid WAN IP';
    }

    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onConfirm = () => {
    const isValid = validateUpdateData();
    if (isValid) {
      onGearEditApi(updateData);
      closeSideBar();
    }
  };
  return (
    <RightNavContainer>
      {/* =========================Header=================================== */}
      <RightNavContainerX onClick={closeSideBar}>
        <RightNavContainerXPar src={cross} />
      </RightNavContainerX>
      <SideBarMainDiv>
        <SDMHeading>Edit AutoPilot Server</SDMHeading>
        {/* =========================Body=================================== */}
        <RightNavSecDiv
          style={{
            padding: '5px',
            marginBottom: '70px',
            paddingBottom: '50px',
          }}
        >
          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>AIR ID</SDMHeadingP>
            <SBMSDiv3>
              <SBMSInput2
                type="text"
                placeholder="0000-0000-0000"
                maxLength={14}
                value={updateData?.air_id}
                readOnly
              />
            </SBMSDiv3>
          </div>

          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>Nickname</SDMHeadingP>
            <SBMSDiv3>
              <SBMSInput2
                type="text"
                placeholder="Enter Nickname"
                maxLength={30}
                onChange={e => {
                  setUpdateData(prev => ({ ...prev, nickname: e.target.value }))
                  setError(prev => ({ ...prev, nickname: '' }));
                }}
                value={updateData?.nickname}
              />
            </SBMSDiv3>
            {error?.nickname && (
              <ErrorWarning>
                {error.nickname}
              </ErrorWarning>
            )}
          </div>

          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>Default LAN IP</SDMHeadingP>
            <input
              type="text"
              className="form-control"
              placeholder="Example: 123.123.123.123"
              maxLength={30}
              value={updateData?.default_lan_ip ?? ''}
              onChange={e => {
                setUpdateData(prev => ({ ...prev, default_lan_ip: e.target.value }));
                setError(prev => ({ ...prev, default_lan_ip: '' }));
              }}
            />
            {error?.default_lan_ip && (
              <ErrorWarning>
                {error.default_lan_ip}
              </ErrorWarning>
            )}
          </div>

          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>Default WAN IP</SDMHeadingP>
            <input
              type="text"
              className="form-control"
              placeholder="Example: 123.123.123.123"
              maxLength={30}
              value={updateData?.default_wan_ip ?? ''}
              onChange={e => {
                setUpdateData(prev => ({ ...prev, default_wan_ip: e.target.value }));
                setError(prev => ({ ...prev, default_wan_ip: '' }));
              }}
            />
            {error?.default_wan_ip && (
              <ErrorWarning>
                {error.default_wan_ip}
              </ErrorWarning>
            )}
          </div>
        </RightNavSecDiv>
      </SideBarMainDiv>
      {/* =========================Footer=================================== */}
      <RightNavContainerFoot>
        <RNCFBtn>
          <TeamHeadBtnImgP onClick={closeSideBar}>Cancel</TeamHeadBtnImgP>
        </RNCFBtn>
        <RNCFBtn2>
          <TeamHeadBtnImgPa onClick={onConfirm}>Confirm</TeamHeadBtnImgPa>
        </RNCFBtn2>
      </RightNavContainerFoot>
    </RightNavContainer>
  );
};

export default EditOrgOnPremServer;
